import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TonConnectUIProvider } from '@tonconnect/ui-react';
export const TonConnectProvider = ({ children }) => (_jsx(TonConnectUIProvider, { manifestUrl: "https://manifests.delab.team/devpn.txt", children: children }));
